import { DeviceGeneralType } from 'store/entities/common/interfaces';
import { CustomerCustomVariableName, type ICustomerDetails } from 'store/entities/customers/interfaces';

export const mockCustomerDetails: ICustomerDetails = {
  customer: {
    id: 'mock-customer-id',
    name: 'Example customer',
    email: 'customer@mail.com',
    geolocation: {
      city: 'New York',
      country: 'United States',
      countryCode: 'US',
      latitude: '40.7128',
      longitude: '-74.0060',
      timezone: 'America/New_York',
    },
    statistics: {
      acceptedGreetingsCount: 0,
      chatsCount: 0,
      greetingsCount: 1,
      visitsCount: 1,
    },
    visitDetails: {
      cameFromURL: 'https://cdn.livechatinc.com',
      lastVisitTimestampInMs: Date.now(),
      userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
      visitStartedTimestampInMs: Date.now(),
      operatingSystem: 'Mac OS X',
      deviceType: DeviceGeneralType.Desktop,
      browserName: 'Chrome',
      isWebCrawler: false,
      wasInvited: true,
    },
    integrations: {},
    customVariables: {
      [CustomerCustomVariableName.SampleCustomer]: '1',
    },
    integrationVariables: {},
  },
  visitedPages: {
    page1: {
      pageURL: 'https://cdn.livechatinc.com/widget/labs/feature/global-mapper',
      timestampInMS: Date.now(),
      title: 'LiveChat',
    },
  },
};
